import { useState } from "react";
import api from "../lib/api";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <label className="block text-xs uppercase tracking-[0.2em] text-[#5979A9]/80 mb-2 font-semibold">Image</label>
      <div className="flex items-center gap-3 flex-wrap">
        {value && (
          <img src={value} alt="" className="w-20 h-20 object-cover rounded-xl border border-[#F0EAE6]" />
        )}
        <label data-testid={`${testid}-button`} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#FAF4F1] hover:bg-[#F0EAE6] text-sm text-[#5979A9] cursor-pointer transition-colors">
          {uploading ? <Loader2 size={16} className="animate-spin"/> : <Upload size={16}/>}
          {uploading ? "Uploading…" : (value ? "Replace image" : "Upload image")}
          <input type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testid}-input`} disabled={uploading}/>
        </label>
      </div>
      {value && (
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={`${testid}-url`}
          className="w-full mt-3 bg-transparent border-b-2 border-[#F0EAE6] focus:border-[#E05947] outline-none py-2 text-xs text-[#4A5568]"
        />
      )}
    </div>
  );
}
